import { render } from "./Sidebar.vue?vue&type=template&id=7d622f5c"
import script from "./Sidebar.vue?vue&type=script&lang=js"
export * from "./Sidebar.vue?vue&type=script&lang=js"

import exportComponent from "/srv/data/www/bylex_platform/cwt2/alpha/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Sidebar.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7d622f5c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7d622f5c', __exports__)) {
    api.reload('7d622f5c', __exports__)
  }
  
  module.hot.accept("./Sidebar.vue?vue&type=template&id=7d622f5c", () => {
    api.rerender('7d622f5c', render)
  })

}


export default __exports__